import axios, { getAuthHeaders } from './config'

export default {
    store: function(comment) {
        return axios.post('/comments', comment, {
            headers: getAuthHeaders()
        })
    },

    all: function(doc) {
        let docID = doc.doc_id;
        return axios.get(`/comments/${docID}`, {
            headers: getAuthHeaders()
        })
    },
    delete: function(commentID) {
        return axios.delete(`/comments/${commentID}`, {
            headers: getAuthHeaders()
        })
    },

    update: function(data) {
        return axios.put(`/comments/${data.commentID}`, data, {
            headers: getAuthHeaders()
        })
    },
    show: function(commentID) {
        return axios.get(`/comments/${commentID}`, {
            headers: getAuthHeaders()
        })
    },
}